import VeloQA from '#client/components/VeloQA';

import FederatedEntry from '../FederatedEntry';

/**
 * Federated entry point for VeloQA component
 *
 * This component wraps VeloQA with the necessary providers
 * for use as a federated module.
 *
 * @param {object} props - Component props
 * @param {string} props.configKey - Config key to lookup VeloQA configuration
 * @param {string} [props.title] - Optional title override
 * @param {string} [props.subtitle] - Optional subtitle override
 * @param {Array} [props.prompts] - Optional prompts override
 * @param {boolean} [props.disabled] - Whether the component is disabled
 * @param {boolean} [props.showCTA] - Whether to show CTA footer
 * @param {string} [props.ctaText] - CTA button text override
 * @param {Function} [props.onThreadCreated] - Callback when thread is created (receives threadUuid)
 * @param {Function} [props.onResponseReceived] - Callback when response is received
 * @returns {object} The wrapped VeloQA component
 */
export default function VeloQAEntry(props) {
  return (
    <FederatedEntry>
      <VeloQA {...props} />
    </FederatedEntry>
  );
}

VeloQAEntry.propTypes = VeloQA.propTypes;
